import {
    URLAPI,
    SUPERVISOR_PATH,
    SUPERVISOR_CREATE_PATH,
    SUPERVISOR_UPDATE_PATH,
    SUPERVISOR_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_supervisor: {
        data: [],

        status: 0,
        message: {},
    },

    _create_supervisor: {
        data: {},
        status: 0,
        message: {},
    },
    _update_supervisor: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_supervisor: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_SUPERVISOR = "GET_ALL_SUPERVISOR";
export const CREATE_SUPERVISOR = "CREATE_SUPERVISOR";
export const UPDATE_SUPERVISOR = "UPDATE_SUPERVISOR";
export const DELETE_SUPERVISOR = "DELETE_SUPERVISOR";

export const supervisor_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_SUPERVISOR:
            return {
                ...state,
                _get_all_supervisor: action.payload,
            };
        case CREATE_SUPERVISOR:
            return {
                ...state,
                _create_supervisor: action.payload,
            };
        case UPDATE_SUPERVISOR:
            return {
                ...state,
                _update_supervisor: action.payload,
            };
        case DELETE_SUPERVISOR:
            return {
                ...state,
                _delete_supervisor: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllSupervisor = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${SUPERVISOR_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_SUPERVISOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_SUPERVISOR,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_SUPERVISOR,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create supervisor
export const createSupervisor = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${SUPERVISOR_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_SUPERVISOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_SUPERVISOR,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_SUPERVISOR,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateSupervisor = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${SUPERVISOR_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_SUPERVISOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_SUPERVISOR,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_SUPERVISOR,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteSupervisor = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${SUPERVISOR_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_SUPERVISOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_SUPERVISOR,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_SUPERVISOR,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_supervisor = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
